import { NbMenuItem } from '@nebular/theme';


export const MY_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'HOME',
    link: '/layouts/home',
    home: true,
  },
  {
    title: 'PRODUCT',
    link: '/layouts/product',
  }, {
    title: 'ABOUT',
    link: '/layouts/about',
  },
  {
    title: 'CONTACT',
    link: '/layouts/contact',
  },


];
